module.exports = __webpack_public_path__ + "img/qrcode.ae4c98e7.png";